import React from 'react';
import config from '../../config';
import numeral from 'numeral';
import styled from 'styled-components';
import { sortByCreated, formatDate, getTransactionInvoiceLink } from 'utils';

export const OrderTransactions = ({ is_postpaid, orderComplete, orderId, items = [], onCharge }) => {
  const renderItem = ({ identifier, debit, is_postpaid, preauth, stripe_charge_id, description, amount, created_on, id, meta = {} }, arr) => {
    return (
      <React.Fragment>
        <tr style={{ 
          fontSize: '0.875em', color: debit ? '#265652' : 'rgb(80 18 18)', 
          backgroundColor: preauth ? '#e0f2fe' : (debit ? 'rgb(206 241 226 / 68%)' : 'rgb(241 206 206 / 68%)')
        }}>
          <td style={{ padding: '0.2em 0.5em' }}>{formatDate(created_on)}</td>
          <td style={{ padding: '0.2em 0.5em' }}>
            {identifier}
          </td>
          <td style={{ padding: '0.2em 0.5em' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {
                  preauth ? 
                  <span style={{ 
                    background:   'rgb(43 133 184 / 12%)',
                    padding:      '0.15rem 0.375rem', 
                    borderRadius: '0.375rem', 
                    marginRight:   '0.375rem', 
                    fontSize:     '12px', 
                    fontWeight:   400, 
                    color:        'rgb(29 70 93)' 
                  }}>
                    Pre-Auth
                  </span>
                : null
              }
              {description}
            </div>
          </td>
          <td style={{ padding: '0.2em 0.5em', width: 180 }}>
            {is_postpaid ? "Monthly Account" : !!(debit || preauth) && meta.last4 && !!meta.brand && 
              <CardContain>
                <CardBrand src={`${config.site.baseName ? `/${config.site.baseName}` : '' }/img/cards/${meta.brand}.svg`} />
                <CardDigits>**** **** **** {meta.last4}</CardDigits>
              </CardContain>
            }
          </td>
          <td style={{ padding: '0.2em 0.5em', width: 120, textAlign: 'center'}}>{debit ? <a target={'_blank'} href={getTransactionInvoiceLink(orderId, id)}>View</a> : "NA"}</td>
          <td style={{ padding: '0.2em 0.5em', width: 120, textAlign: 'right' }}>{numeral(amount).format('$0,0.00')}</td>
        </tr>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <table style={{ width: '100%' }}>
        <tbody>
          <tr style={{ backgroundColor: '#495e6a' }}>
            <Th>Date</Th>
            <Th>Reference</Th>
            <Th>Description</Th>
            <Th style={{ textAlign: 'left' }}>{is_postpaid ? 'Payment' : 'Card'}</Th>
            <Th style={{ textAlign: 'center' }}>Invoice</Th>
            <Th style={{ textAlign: 'right' }}>Amount</Th>
          </tr>
          {sortByCreated([ ...items ]).map(renderItem)}
        </tbody>
      </table>
    </React.Fragment>
  );
};

const CardDigits = styled.span`
  letter-spacing: 0.05em;
`;

const CardContain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardBrand = styled.img`
  height: 20px;
  margin-right: 4px;
`;

const Th = styled.th`
  text-align: left;
  font-family: 'Roboto';
  font-size: 0.9em;
  font-weight: 400;
  margin-bottom: 4px;
  color: #ffffff;
  padding: 0em 0.5em;
`;

OrderTransactions.defaultProps = {
  onCharge: () => null
};

export default OrderTransactions;
